import React from 'react'
import dynamic from 'next/dynamic'

// next/dynamic drops the generic type parameter of PreviewMode, so restore its type
const PreviewMode = dynamic(() => import('./PreviewMode')) as typeof import('./PreviewMode').default

export default function SanityPreview<T>({
  preview,
  initialData,
  children,
  ...props
}: {
  preview: boolean
  initialData: T
  children: (data: T) => React.ReactNode
  query: string
  params?: Record<string, unknown>
}) {
  if (!preview) {
    return children(initialData)
  }
  return (
    <PreviewMode {...props} initialData={initialData}>
      {children}
    </PreviewMode>
  )
}
